import { render, staticRenderFns } from "./DashboardWidget.vue?vue&type=template&id=519c0a32&"
import script from "./DashboardWidget.vue?vue&type=script&lang=ts&"
export * from "./DashboardWidget.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardWidget.vue?vue&type=style&index=0&id=519c0a32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports